import { REACT_APP_API_CLIENT_KEY } from '../config';

export function getHeaders(apiKey: string): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('X-Api-Key', apiKey);
    headers.append('x-user', 'ole-web-application');
    return headers;
}

export function getHeadersApplication(): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('X-Api-Key', REACT_APP_API_CLIENT_KEY);
    headers.append('x-user', 'ole-web-application');
    return headers;
}

export function getHeadersFiles(): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('X-Api-Key', REACT_APP_API_CLIENT_KEY);
    headers.append('x-user', 'ole-web-application');
    return headers;
}

export function getHeadersOtp(): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('X-Api-Key', 'admin');
    headers.append('x-user', 'ole-web-application');
    return headers;
}